(() => {
  if (window.spaceArmoryPolicySheet) return;
  window.spaceArmoryPolicySheet = true;
  const openers = new WeakMap();
  document.addEventListener('click', event => {
    const control = event.target instanceof Element ? event.target.closest('[data-policy-open], [data-policy-close]') : null;
    if (!control) return;
    const root = control.closest('face-fit-scanner');
    const sheet = root?.querySelector('[data-policy-dialog]');
    if (!sheet) return;
    event.preventDefault();
    if (control.hasAttribute('data-policy-open')) {
      if (sheet.open) return;
      openers.set(sheet, control);
      sheet.querySelector('.face-fit-policy__content').scrollTop = 0;
      sheet.showModal();
    } else sheet.close();
  });
  document.addEventListener('close', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (target.matches('[data-policy-dialog]')) {
      const control = openers.get(target);
      openers.delete(target);
      if (control?.isConnected && control.closest('.face-fit__dialog')?.open) control.focus({preventScroll:true});
    } else if (target.matches('.face-fit__dialog')) {
      const sheet = target.closest('face-fit-scanner')?.querySelector('[data-policy-dialog]');
      if (sheet?.open) sheet.close();
    }
  }, true);
})();
